import { createAction, handleActions } from 'redux-actions';

import { setSelectedDate } from './supervisordashboard';

export const setScheduleDate = createAction('SUPERVISOR_SCHEDULE/SET_SCHEDULE_DATE');
export const clearCurrentDate = createAction('SUPERVISOR_SCHEDULE/CLEAR_SCHEDULE_DATE');

const INITIAL_STATE = {
  currentDate: null,
};

export default handleActions(
  {
    'SUPERVISOR_SCHEDULE/CLEAR_SCHEDULE_DATE': (state) => ({
      ...state,
      currentDate: null,
    }),
    'SUPERVISOR_SCHEDULE/SET_SCHEDULE_DATE': (state, action) => ({
      ...state,
      currentDate: action.payload,
    }),
  },
  INITIAL_STATE,
);

export function setCalendarDate(date) {
  return (dispatch) => {
    dispatch(setScheduleDate(date));
    dispatch(setSelectedDate(date));
  };
}

export function clearSupervisorScheduleData() {
  return (dispatch) => {
    dispatch(clearCurrentDate());
  };
}
